export const blockIconsAudioandvideoPauseNew = (
	<span className='material-symbols-outlined'>pause</span>
);
